@if (!!financialAttributes && !isLoading) {
<div class="attribute-section">
  <p class="app__template--linked--header">{{ screenWidth > 480 ? 'Financial ' : '' }}Attributes</p>
</div>
} @if (isLoading) {
<div class="app__form--attributes--card">
  <div class="loader-container">
    <div class="loader-body w-full mr-0">
      <div class="ph-item loader-body-item">
        <div class="ph-col-12 p-0">
          <div class="ph-row mt-[-16px]">
            <div class="ph-col-12 h-6"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
} @if(!isLoading){ @for (attribute of attributesList(); track $index) { @if (!isBalanceAttribute(attribute)) {

<div class="app__addDocument-card-wrapper pb-0">
  <div class="app__addDocument-card-top">
    <div class="flex flex-col">
      <p class="app__addDocument-card-title flex items-center gap-2">
        {{ attribute?.value?.title ?? attribute?.key }}
        @if(isHighPriorityAttribute(attribute)){
        <img src="/assets/images/high-priority-flag-icon.svg" matTooltip="High Priority Item" matTooltipPosition="above" alt="High Priority Item" />
        }
      </p>
    </div>
    <div class="flex full-width">
      <button
        class="app__addDocument-addButton"
        [disabled]="isRemoveEditSaveSharing"
        (click)="!isRemoveEditSaveSharing && openFormDialog(attribute?.getFormValues?.attribute, attribute, 'create')"
      >
        <p
          class="app__form--attribute--add--btn"
          [ngClass]="{ 'hover:cursor-pointer': !isRemoveEditSaveSharing, 'text-[#C1C2C5] hover:cursor-default': isRemoveEditSaveSharing }"
        >
          <span class="material-icons text-xl">add</span> Update
        </p>
      </button>
    </div>
  </div>
  <div class="app__addDocument-card-bottom pb-0">
    @for (input of attribute?.value?.inputs; track i; let i = $index; let last = $last) {

    <div [class]="'app__addDocument-card-bottom-list flex items-center justify-between' + ' ' + (last ? 'border-0' : ' ')">
      <p class="text-sm flex items-center">
        {{ input?.title ?? '' }}
        @if(input?.toolTip){
        <span class="material-icons text-base material-symbols-outlined pl-2 cursor-pointer mt-1" [matTooltip]="input?.toolTip"> info</span>
        }
      </p>
      <b class="font-semibold text-lg my-[0.5rem]"> </b>
      <b [class]="handleStyleClassForAttributeValues(input, attribute, i)">
        @if(!attribute?.getFormValues || (!attribute?.getFormValues[input?.key] && attribute?.getFormValues[input?.key] !=0) ){
        {{ getAttributeItemValue(input) }}
        }@else { @if(input?.type == 'Dollar Input'){
        {{
          !!attribute?.getFormValues[input.key]
            ? (attribute?.getFormValues[input.key] | currency : 'USD' : true : '1.2-2')
            : attribute?.getFormValues[input.key] == 0
            ? (attribute?.getFormValues[input.key] | currency : 'USD' : true : '1.2-2')
            : '-'
        }}
        } @else if(input?.type == 'Numeric Input'){
        {{ !!attribute?.getFormValues[input.key] ? (attribute?.getFormValues[input.key] | number : '1.2-2') : '-' }}
        } @else if(input?.type == 'Text Input'){
        {{ !!attribute?.getFormValues[input.key] ? attribute?.getFormValues[input.key] : '-' }}
        } @else if(input?.type == 'Percentage'){
        {{ attribute?.getFormValues[input.key] + '%' ?? '' }}
        } @else if(input?.type == 'Switch'){
        {{ convertSwitchBooleanValueToString(attribute?.getFormValues[input.key]) }}
        } @else if(input?.key == 'effective_date' || input?.type == 'Date Selection'){
        {{ !!attribute?.getFormValues[input.key] ? (attribute?.getFormValues[input.key] | date : 'MMM d yyyy') : '-' }}
        } @else if(!!input?.default &&input?.default == 'Not Editable'){
        {{
          (input.type == 'Income & Expense' ? income_expense_sub_class : input.type == 'Assets & Liabilities' ? attribute_sub_class : '') | titlecase
        }}
        } @else{
        {{ attribute?.getFormValues[input.key] ?? '' }}
        } }
      </b>
    </div>
    }
  </div>
  @if (!!attribute.getFormValues && hasHistory(attribute) ) {
  <report-card-networth
    [attribute_type]="'financial'"
    [fromBalanceRegister]="true"
    [fromCurrentBalance]="true"
    [report]="{ name: 'History' }"
    [index]="51"
    [currentFormId]="currentFormId"
    [balanceType]="attribute?.value?.vault_form_code"
    [connected_to_institution]="connected_to_institution"
    [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
    [mode]="mode"
    [currentVaultUserId]="currentVaultUserId ?? currentuserId"
    [attribute]="attribute"
    [isBalanceTwo]="true"
    [attributeValues]="attribute?.getFormValues"
    [financialAttributes]="financialAttributes"
    (RegisterBalanceComponentEmitter)="handleRegisterBalanceComponentEmitter($event)"
    [fromAttribute]="true"
  >
  </report-card-networth>
  }
</div>
<br />
} @if (attribute.value.History && !isLoadingBalance()) {

<app-current-balance-card
  [currentuserId]="currentuserId"
  [isHighPriorityAttribute]="isHighPriorityAttribute(attribute)"
  [formData]="data"
  [attribute_type]="'financial'"
  [attribute]="attribute"
  (openFormDialogEmitter)="openFormDialog(attribute?.value?.vault_form_code, attribute, 'create', $event)"
  [currentFormId]="currentFormId"
  [connected_to_institution]="connected_to_institution"
  [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
  [mode]="mode"
  [templateId]="templateId"
  [selectedFileList]="selectedFileList"
  [formName]="formName"
  [currentVaultUserId]="currentVaultUserId"
  [financialAttributes]="financialAttributes"
  [isFromTemplate]="isFromTemplate"
  (RegisterBalanceComponentEmitter)="handleRegisterBalanceComponentEmitter($event)"
  (balanceDataEmitter)="handleBalanceDataEmitter($event)"
  [attributeClasses]="{
income_expense_class: income_expense_class,
attribute_sub_class: attribute_sub_class,
income_expense_sub_class: income_expense_sub_class,
attribute_class: attribute_class,

  }"
></app-current-balance-card>
<br />

} } @if (!!has_transaction) { @if (attributesList().length) {
<br />
}
<add-transaction-attribute
  #childTransactionAttribute
  [connected_to_institution]="connected_to_institution"
  [currentFormId]="currentFormId"
  [currentValutUserId]="currentVaultUserId"
  [name]="'Transactions'"
  [mode]="mode"
  [data]="data"
  [currentuserId]="currentuserId"
  [fId]="fId"
  [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
  [userId]="currentVaultUserId"
>
</add-transaction-attribute>
}
<linked-transaction-count
  [currentFormId]="currentFormId"
  [mode]="mode"
  [data]="data"
  [name]="name"
  [countList]="countList"
  [currentuserId]="currentuserId"
  [connected_to_institution]="connected_to_institution"
  [fId]="fId"
  [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
  [userId]="currentVaultUserId"
  (updateCountListEvent)="updateCountList($event)"
>
</linked-transaction-count>

<br />
@if (hasDistribution()) {
<app-distribution-card
  [formData]="data"
  [attribute_type]="'financial'"
  [attribute]="distribution"
  (openFormDialogEmitter)="openFormDialog(distribution?.value?.vault_form_code, distribution, 'create', $event)"
  [currentFormId]="currentFormId"
  [connected_to_institution]="connected_to_institution"
  [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
  [mode]="mode"
  [currentVaultUserId]="currentVaultUserId"
  [financialAttributes]="financialAttributes"
  [isFromTemplate]="isFromTemplate"
  (RegisterBalanceComponentEmitter)="handleRegisterBalanceComponentEmitter($event)"
  (balanceDataEmitter)="handleBalanceDataEmitter($event)"
  [attributeClasses]="{
income_expense_class: income_expense_class,
attribute_sub_class: attribute_sub_class,
income_expense_sub_class: income_expense_sub_class,
attribute_class: attribute_class,
  }"
></app-distribution-card>
<br />
} @if (hasCapitalCommitment()) {
<app-capital-commitment-card
  [formData]="data"
  [attribute_type]="'financial'"
  [attribute]="capitalCommitment"
  (openFormDialogEmitter)="openFormDialog(capitalCommitment?.value?.vault_form_code, capitalCommitment, 'create', $event)"
  [currentFormId]="currentFormId"
  [connected_to_institution]="connected_to_institution"
  [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
  [mode]="mode"
  [currentVaultUserId]="currentVaultUserId"
  [financialAttributes]="financialAttributes"
  [isFromTemplate]="isFromTemplate"
  (RegisterBalanceComponentEmitter)="handleRegisterBalanceComponentEmitter($event)"
  (balanceDataEmitter)="handleBalanceDataEmitter($event)"
  [attributeClasses]="{
  income_expense_class: income_expense_class,
  attribute_sub_class: attribute_sub_class,
  income_expense_sub_class: income_expense_sub_class,
  attribute_class: attribute_class,
    }"
></app-capital-commitment-card>
<br />
} }
